/**
 * 走子
 * @param boardArray Array<Array<pieces color or null>>
 * @param x Number
 * @param y Number
 * @param c Number
 * @return Array<Array<pieces color or null>>
 */
export function playStepAt(boardArray, x, y, c) {
	let copyBoard=[];
	for(var i = 0; i < boardArray.length; i++){
		copyBoard[i]=[];
		for (var j = 0; j < boardArray.length; j++){
			copyBoard[i][j]=boardArray[i][j];
		}
	}
	copyBoard[x][y] = c;
	let deadStones = calcDeadStonesAround(copyBoard, x, y);

	removeDeadStones(copyBoard, deadStones);
	return copyBoard;
}
export function playStep(boardArray, step) {
	let {x,y,c,error}=stepToXYC(step);
	if (error){
		return boardArray;
	}else{
		return playStepAt(boardArray,x,y,c);
	}
}


/**
 * 根据步骤获取 boardArray
 */
export function stepsToBoardArray(rootSteps, stepIndex, boardSize = 19) {
	let boardArray=createEmptyBoard(boardSize);
	if (stepIndex instanceof Number){
		stepIndex=[stepIndex];
	}
	let steps = rootSteps;
	for (var i = 0; i < stepIndex.length; i++) {
		for(var j = 0; j <= stepIndex[i]; j++) {
			let step=steps[j];
			if (!(step instanceof Array)) {
				boardArray = playStep(boardArray, step);
			}
		}
		steps = steps[stepIndex[i]];
	}
	return boardArray
}

/**
 * 根据当前StepIndex获取下一步StepIndex
 * @param steps parseSgf返回的对象 sgf树
 * @param stepIndex0 Array or Number
 * @param x
 * @param y
 * @param c step
 * @return stepIndex
 */
export function nextStepIndex(rootSteps, stepIndex, x, y, c) {
	let stepIndexes = nextStepIndexes(rootSteps, stepIndex);
	for (var i = 0; i < stepIndexes.length; i++) {
		let index = stepIndexes[i];
		if (stepIsMatch(indexToStep(rootSteps, index), x, y, c)) {
			return index
		}
	}
	return null;
}

export function nextStepIndexes(rootSteps, stepIndex) {
	if (stepIndex instanceof Number){
		stepIndex=[stepIndex];
	}
	let steps = rootSteps;
	for (var i = 0; i < stepIndex.length-1; i++) {
		steps = steps[stepIndex[i]];
	}
	/**
	 * 拿到当前steps和index，这样就好拿到下一个节点了；
	 然后首先检查下一个兄弟节点
	 再检查下面的几个分支
	 */
	let currentSteps=steps;
	let index=stepIndex[stepIndex.length-1];
	let branches=[];
	let nextStep=null;
	for (var i=index+1;i<currentSteps.length;i++){
		if (!(currentSteps[i] instanceof Array)){
			nextStep=currentSteps[i];
			break;
		}else{
			branches.push(currentSteps[i]);
		}
	}
	/**
	 * 此时我们得到了branches就是接下来的分支；nextStep就是兄弟节点
	 */
	 let stepIndexes = [];
	if (nextStep != null){
		//匹配上了兄弟节点
		let copy = [...stepIndex];
		copy[copy.length - 1] += branches.length + 1;
		stepIndexes.push(copy);
	}
	for (var i = 0; i < branches.length; i++) {
		let copy = [...stepIndex];
		copy[copy.length - 1] += i + 1;
		copy.push(0);
		stepIndexes.push(copy);
	}
	return stepIndexes;
}
/**
 * 对比两个board
 */
export function diff(newBoard, oldBoard) {
	let luozi = [];
	let tizi = []
	for (var x = 0; x < newBoard.length; x++) {
		if (oldBoard[x] === undefined) {
			for (var y = 0; y < newBoard[x].length; y++) {
				if (newBoard[x][y] != 0) {
					luozi.push({
						x,
						y,
						c: newBoard[x][y]
					})
				}
			}
		} else {
			for (var y = 0; y < newBoard[x].length; y++) {
				if (newBoard[x][y] !== oldBoard[x][y]) {
					if (newBoard[x][y] !== 0) {
						luozi.push({
							x,
							y,
							c: newBoard[x][y]
						})
					} else if (oldBoard[x][y] !== undefined) {
						tizi.push({
							x,
							y,
							c: oldBoard[x][y]
						})
					}
				}
			}
		}
	}

	return {luozi, tizi};
}



function stepIsMatch(step,x1,y1,c1) {
	if (step == null) {
		return false;
	}
	let {x,y,c} = stepToXYC(step);
	return x == x1 && y == y1 && c == c1
}

/**
 * 获取step
 */
export function indexToStep(rootSteps, stepIndex) {
	let steps = rootSteps;
	for (var i = 0; i < stepIndex.length; i++) {
		steps = steps[stepIndex[i]];
	}
	return steps;
}

/**
 * 获取tags
 */
export function getTags(rootSteps, boardSize) {
	let lb = rootSteps.filter((item) => item.tag == "LB")
	let size = boardSize || parseInt(rootSteps.find((item) => item.tag == "SZ").tagValue) || 19
	let tags = createEmptyBoard(size)
	lb.forEach((item) => {
		let x = item.tagValue.charCodeAt(0)-'a'.charCodeAt(0)
		let y = item.tagValue.charCodeAt(1)-'a'.charCodeAt(0)
		tags[x][y] = item.tagValue.charAt(3)
	})
	return tags
}


export function createEmptyBoard(boardSize){
	var boardArray=[];
	for(var i=0;i<boardSize;i++){
		boardArray[i]=[];
		for (var j=0;j<boardSize;j++){
			boardArray[i][j]=0;
		}
	}
	return boardArray;
}

function stepToXYC(step){
	let x = step.tagValue.charCodeAt(0)-'a'.charCodeAt(0);
	let y = step.tagValue.charCodeAt(1)-'a'.charCodeAt(0);
	let c=0;
	if (['B','AB'].includes(step.tag)){
		c=1;
	}else if (['W','AW'].includes(step.tag)){
		c=-1;
	}else{
		return {error:"not playable"};
	}
	return {x,y,c};
}


let o = {
	x:1,
	y:1,
	c:1,
	next: [{
		x:2,
		y:2,
		c:2,
		next: [{}]
	}]
}

export function parseSgf(sgf) {
	// 问题描述  C[请提只剩两口气的黑棋。]
	var desc = "";
	var desc_result = /C\[([.\s\S]*?)\]/.exec(sgf);
	if (desc_result != null) {
		desc = desc_result[1];
	}

	var state = 0;
	var lastTag = "C";
	var tag = "";
	var tagValue = "";
	var value = "";
	var root=[];
	var nodeList = root;
	var stack = [];
	var closedJustNow = false;
	for (var i = 0; i < sgf.length; i++) {
		let c = sgf.charAt(i);
		if (state == 0) {
			switch (c) {
				case '[':
					closedJustNow = false;
					tag = value;
					value = "";
					tagValue = "";
					state = 1;
					break;
				case '(':
					closedJustNow = false;
					stack.push(nodeList);
					nodeList = [];
					break;
				case ')':
					if (!closedJustNow) {
						closedJustNow = true;
						var branchString = "";
					}
					var lastNodeList=nodeList;
					nodeList = stack.pop();
					nodeList.push(lastNodeList);
					break;
				case ';':
					break;
				default:
					value += c;
					break;
			}
		} else if (state == 1) {
			switch (c) {
				case ']':
					tagValue = value;
					if (tag == "")tag = lastTag;
					lastTag = tag;
					var node = {tag: tag, tagValue: tagValue};
					nodeList.push(node);
					value = "";
					tag = "";
					tagValue = "";
					state = 0;
					break;
				default:
					value += c;
					break;
			}

		}
		else {
		}
	}
	return root;
}

/**
 * 计算周围的死子
 */
export function calcDeadStonesAround(boardArray, x, y) {
	let dx = [1,0,-1,0];
	let dy = [0,1,0,-1];
	let deadStones = [];
	let c = boardArray[x][y];
	for (var d = 0; d < 4; d++) {
		let x1 = x + dx[d];
		let y1 = y + dy[d];
		deadStones = [...deadStones, ...calcDeadStonesAt(boardArray, x1, y1, -c)];
	}
	if (deadStones.length == 0) {
		deadStones = [...deadStones, ...calcDeadStonesAt(boardArray, x, y, c)];
	}
	return deadStones;
}

/**
 * 计算死子
 */
function calcDeadStonesAt(boardArray, x, y, c) {
	let stones = calcStonesAt(boardArray, x, y, c);
	let qi = calcStonesQiAt(boardArray, stones);
	if (qi == 0) {
		return stones;
	}
	return [];
}

/**
 * 连在一起的一串棋子
 */
function calcStonesAt(boardArray, x, y, c) {
	if (y < 0 || y >= boardArray.length) {
		return [];
	}
	if (x < 0 || x >= boardArray.length) {
		return [];
	}
	if (boardArray[x][y] !== c) {
		return [];
	}
	let stones = [{x, y}];
	let dx = [1,0,-1,0];
	let dy = [0,1,0,-1];
	for (var i = 0; i < stones.length; i++) {
		for (var d = 0; d < 4; d++) {
			let x1 = stones[i].x + dx[d];
			let y1 = stones[i].y + dy[d];
			if (boardArray[x1] && boardArray[x1][y1] == c) {
				if(stones.filter((item) => item.x == x1 && item.y == y1).length == 0) {
					stones.push({x:x1,y:y1});
				}
			}
		}
	}
	return stones;
}
/**
 * 一串棋子的气
 */
function calcStonesQiAt(boardArray, stones) {
	let dx = [1,0,-1,0];
	let dy = [0,1,0,-1];
	let qi = 0;
	for (var i = 0; i < stones.length; i++) {
		for (var d = 0; d < 4; d++) {
			let x1 = stones[i].x + dx[d];
			let y1 = stones[i].y + dy[d];
			if (boardArray[x1] && boardArray[x1][y1] == 0) {
				if(stones.filter((item) => item.x == x1 && item.y == y1).length == 0) {
					qi++;
				}
			}
		}
	}
	return qi;
}

export function test(boardArray, x, y, c) {
	return calcDeadStonesAround(boardArray, x, y, c);
}

function removeDeadStones(boardArray, deadStones) {
	for (var i = 0; i < deadStones.length; i++) {
		boardArray[deadStones[i].x][deadStones[i].y] = 0;
	}
}



// WEBPACK FOOTER //
// ./components/go/go.js